function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "css_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "css_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#css_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "css-3-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "css-3-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#css_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.98438 45L21.875 50L39.7594 45.0031L43.75 0L0 0L3.98438 45Z",
  transform: "translate(3.125 0)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.7031 11.1688L25.1844 28.1156L13.85 31.25L13.8406 31.2531L2.5125 28.1156L1.72187 19.2531L7.27187 19.2531L7.68437 23.85L13.8438 25.5125L13.8469 25.5094L20.0156 23.8469L20.8562 16.1875L1.45625 16.2406L0.90625 11.0031L21.3219 10.7625L21.7344 5.15625L0.359375 5.21562L0 0L13.85 0L27.7 0L27.2063 5.51563L26.7031 11.1688Z",
  transform: "translate(11.150391 9.200195)",
  id: "Vector",
  fill: "#140F3D",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgCss = function SvgCss(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCss, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/css.63c68865.svg";
export { ForwardRef as ReactComponent };